// growth-picker.ts — (owner, 2026-10-05: the growth UI fixes) which characters the growth page offers. A character with
// no photo (the "Kai (variant)" rows that show only an initial) or no name is not offered: a video would star someone
// nobody has seen or named. They are counted, so the page can say how many wait on the Characters page.
export function readyCharacters<T extends { previewUrl?: string | null; displayName?: string | null }>(all: readonly T[]): { ready: T[]; hidden: number } {
  const ready = all.filter((c) => !!c.previewUrl && !!c.displayName?.trim());
  return { ready, hidden: all.length - ready.length };
}
